import { Provider } from '@angular/core';
import { SessionDataService } from '@helpers/services/session-data.service';
import { SessionDataKeys } from '@helpers/types/models';

export function provideSessionData<T>(key: SessionDataKeys): Provider {
	return {
		provide: SessionDataService,
		useFactory: (): SessionDataService<T> => {
			const service = new SessionDataService<T>();
			service.STORAGE_KEY = key;
			return service;
		},
	};
}
